import React, { useState } from "react";

const ImageGallery = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  return (
    <div id="Images" className="container mt-5">
      <h2
        className="text-start"
        style={{ marginTop: "100px", textDecoration: "underline" }}
      >
        Nos derniers projets:
      </h2>
      <div className="row mt-3">
        {images.map((image, index) => (
          <div className="col-md-4 mb-4" key={index}>
            <div className="card">
              <img
                src={image.src}
                alt={image.alt}
                className="card-img-top"
                style={{
                  height: "200px",
                  objectFit: "cover",
                  cursor: "pointer",
                }}
                onClick={() => handleImageClick(image)}
              />
            </div>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.8)" }}
          onClick={handleCloseModal}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{selectedImage.title}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>
              <div className="modal-body" style={{ padding: 0 }}>
                <img
                  src={selectedImage.src}
                  alt={selectedImage.alt}
                  className="img-fluid"
                  style={{ width: "100%", height: "80%", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageGallery;
